import { WeightableEntityWithResult } from '@upright/common/model/output/scores/model-entity-data/types/types-weightable';
import { range } from 'lodash';
import { pickDefaultModelResult } from '../../../../../../../common/model/data-point-pickers';
import { ModelEntityWithScores } from '../../../../../../../common/model/output/scores/model-entity-data/types';
import { SortableTable } from '../../../../../generic/content/tables/sortable-table';
import { getTableData } from './table-data';

export enum TopHoldingsTableType {
  WEIGHT,
  // TODO should this be removed?
  NET_IMPACT_RATIO,
}

interface Props {
  type: TopHoldingsTableType;
  scoreData: ModelEntityWithScores | undefined;
  itemData: WeightableEntityWithResult[] | null | undefined;
  loadingFinished: boolean;
}

export function TopHoldingsTable(props: Props) {
  const scoreData = props.scoreData;
  const itemData = props.itemData;

  const modelResults = scoreData?.modelResults;
  const modelResult = modelResults && pickDefaultModelResult(modelResults);
  const weightSetId = modelResult?.weightSetId;
  const limit = Number.MAX_SAFE_INTEGER;

  const itemDataToDisplay = (() => {
    if (!props.loadingFinished) {
      return range((scoreData && Math.min(limit, scoreData.modelResults[0]?.itemCount || 0)) || 5).map(() => undefined);
    }
    if (!weightSetId) {
      return [];
    }
    return itemData || [];
  })();

  const tableData = getTableData(itemDataToDisplay, scoreData, weightSetId, props.type);

  return (
    <div>
      <SortableTable data={tableData} defaultSortKey="name" disableDownloadLink={true} />
    </div>
  );
}
